var _g, _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWheelSocial(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 13.5,
    r: 13.5,
    fill: "#FFCA28"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M26.6274 13.2825C26.6274 10.8747 25.671 8.56563 23.9684 6.86311C22.2659 5.16058 19.9568 4.20412 17.5491 4.20412C15.1413 4.20412 12.8322 5.16058 11.1297 6.86311C9.42717 8.56563 8.4707 10.8747 8.4707 13.2825L13.0782 13.2825C13.0782 12.0967 13.5493 10.9596 14.3877 10.1211C15.2261 9.28267 16.3633 8.81163 17.5491 8.81163C18.7348 8.81163 19.872 9.28267 20.7104 10.1211C21.5489 10.9596 22.0199 12.0967 22.0199 13.2825H26.6274Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.47021 13.6217C8.47021 15.228 8.89303 16.8059 9.69616 18.197C10.4993 19.5881 11.6545 20.7432 13.0455 21.5464L15.383 17.4979C14.7025 17.105 14.1375 16.54 13.7447 15.8596C13.3519 15.1792 13.1451 14.4074 13.1451 13.6217L8.47021 13.6217Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M13.3258 21.5142C14.6227 22.263 16.0938 22.6572 17.5913 22.6572C19.0889 22.6572 20.56 22.263 21.8569 21.5142L19.571 17.5549C18.9691 17.9024 18.2864 18.0854 17.5913 18.0854C16.8963 18.0854 16.2136 17.9024 15.6117 17.5549L13.3258 21.5142Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M22.0756 21.4247C23.4666 20.6215 24.6218 19.4664 25.4249 18.0753C26.2281 16.6842 26.6509 15.1063 26.6509 13.5L21.976 13.5C21.976 14.2857 21.7692 15.0575 21.3764 15.7379C20.9836 16.4183 20.4186 16.9833 19.7381 17.3762L22.0756 21.4247Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 35,
    height: 35,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelSocial);
export default __webpack_public_path__ + "static/media/wheel_social.4d75bcf1.svg";
export { ForwardRef as ReactComponent };